<input
  #input
  class="custom-input"
  [formControl]="inputControl"
  [ngClass]="{ invalid: isDuplicate }"
  (keydown)="onKeyDown($event)"
/>

@if (isDuplicate) {
  <div class="error-message">{{ duplicateMessage }}</div>
}
